<template>
    <div class="cash-withdrawal" style="padding-top: 1rem" v-if="is_load">
        <!--<navTitle title="余额提现"></navTitle>-->
        <navTitle :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'Penarikan'" path="/user"></navTitle>

        <div class="isnull" v-if="showTips==='0'||showTips==='true'">
            Anda dapat menarik uang setelah mengikat rekening bank (akun yang salah tidak akan diubah)
            <div class="isnull-btn" @click="$router.push({ path: '/user/myPay' })">
                Bind bank
            </div>
        </div>

        <div style="width: 7.5rem;height: 30px;margin:0 auto;left:0;right:0;background: rgba(254, 211, 44, 0.6);z-index: 10;position: fixed;">
            <!--      <svg style="font-size: .35rem;margin: 4px;float: left;color: #333" t="1635247381974" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4483" width="200" height="200"><path d="M553.141571 59.499589a43.664726 43.664726 0 0 0-47.54116 6.253491l-255.990857 218.616193-204.061284-0.841113h-0.07314a43.884147 43.884147 0 0 0-31.377165 13.274954 46.041784 46.041784 0 0 0-13.128674 32.291418L0.018468 694.283776a46.370915 46.370915 0 0 0 12.982393 32.364558 43.884147 43.884147 0 0 0 31.523446 13.421235h206.511482l254.747473 217.81165a43.664726 43.664726 0 0 0 47.541159 6.21692 45.749223 45.749223 0 0 0 25.599086-41.360808V100.823828a45.785793 45.785793 0 0 0-25.599086-41.324239z m172.610978 228.343845a43.884147 43.884147 0 0 0-58.695047 21.466662 46.553766 46.553766 0 0 0 20.332988 60.925824 150.668905 150.668905 0 0 1 69.483233 138.271633c0 108.174422-62.352059 144.013142-64.436556 145.183387a46.261205 46.261205 0 0 0-19.930717 61.291525 44.432699 44.432699 0 0 0 39.898004 25.269955 43.481876 43.481876 0 0 0 19.857577-4.790686c4.644406-2.413628 113.623371-60.267562 113.62337-226.954181a239.607443 239.607443 0 0 0-120.169422-220.664119z m138.600764-134.139209a43.884147 43.884147 0 0 0-61.181815 13.677226 46.553766 46.553766 0 0 0 12.909253 63.120031c4.827256 3.254741 118.889468 82.977608 118.889469 281.370523s-109.417807 278.664333-113.769651 281.589943a46.370915 46.370915 0 0 0-12.360702 63.339452 43.884147 43.884147 0 0 0 61.766937 12.653262c6.253491-4.278704 153.375094-107.735581 153.375094-357.728938S870.862795 157.873219 864.353313 153.594514z m0 0" p-id="4484"></path></svg>-->
            <div style="line-height: 30px;color: #333;text-align: center">Penarikan hari ini:
                Rp{{today_total_withdraw_money | MoneyFormat}}
            </div>
        </div>
        <div v-if="showTips==='false'">
            <div class="value-item">
                <div class="T1">Jumlah penarikan</div>
                <!--<div class="flex">-->
                <!--<div class="I1">{{icon_moeny}}</div>-->
                <!--<input type="number" @keyup="getwithdraw_fee" v-model="post.money" />-->
                <!--</div>-->

                <div class="money-switch" style="padding-bottom: 0px">
                    <div class="switch-item" :class="switch_index==index?'switch-click':''"
                         v-for="(item,index) in money_switch"
                         v-key="index" @click="switchItem(item,index)">{{icon_moeny}}{{item | MoneyFormat}}
                    </div>
                </div>

                <!--<div class="min"></div>-->
                <div class="max">
                    Saldo: {{icon_moeny}}{{ now_money | MoneyFormat }}
                    <!--<span class="href" @click="upAll">Withdraw all</span>-->
                </div>
            </div>
            <div class="row-info" style="height:auto" v-if="!showError">
                Proses biaya: {{icon_moeny}}{{ realFree | MoneyFormat}}<br/>Jumlah aktual:
                {{icon_moeny}}{{ realPrice | MoneyFormat}}
            </div>
            <div class="row-error" v-else>
                {{errorMsg}}
            </div>

            <div class="row-wrap">
                <div class="row-T1">Penarikan akun</div>
                <div class="row">
                    <div class="row-name">Nomor Akun</div>
                    <input class="input" placeholder="" v-model="my_cash.bank_card" disabled="disabled"/>
                </div>
                <div class="row">
                    <div class="row-name">Nama pemegang</div>
                    <input class="input" placeholder="Please select service provider" v-model="my_cash.bank_holder"
                           disabled="disabled"/>
                </div>
                <!--<div class="row">-->
                <!--<div class="row-name">手机号</div>-->
                <!--<input class="input" placeholder="请填写卡号" v-model="post.cardnum" />-->
                <!--</div>-->
            </div>
            <div class="submit bg-color-blue" @click="submitted">withdraw</div>
<!--            <div class="submit bg-color-blue" @click="test">test</div>-->
        </div>
        <div id="forPop" v-if="yz_pwd" @click="bgClose"></div>
        <div v-if="yz_pwd" class="set-pwd">
            <div class="tx-pwd-title">Tetapkan sandi penarikan</div>
            <div class="row">
                <input type="password" class="input" placeholder="Sandi tarik" v-model="withdraw_pwd"/>
            </div>
            <div class="set-tx-pwd-btn bg-color-blue" @click="inputPassword">Konfirmasi</div>
            <div class="set-tx-pwd-btn bg-qx" @click="bgClose">Tutup</div>
            <div style="clear: both"></div>
            <div class="forget-password" @click="forgetPassword">Lupa kata sandi penarikan</div>
        </div>
        <div>
            <mt-popup v-model="showPopup" style="padding: 5px;border-radius: 5px;">
                <div style="width: 290px;padding: 5px">
                    First withdrawal verification {{phone}}
                </div>
                <mt-field placeholder="6 digit dalam SMS" v-model="captcha" style="border-bottom: 1px solid #ddd;margin: 5px 0">
                    <Button v-if="countdown===0" type="primary" size="small" @click="code()" style="background-color: #00c3f9">
                        send
                    </Button>
                    <Button v-else type="primary" size="small" disabled style="background-color: #00c3f9">
                        {{countdown}}
                    </Button>
                </mt-field>
                <div style="display: flex;align-items: center;justify-content: center;">
                    <!--                        <mt-button style="flex: 1" @click="inputCancel" plain>取消</mt-button>-->
                    <Button type="primary" size="small" style="border: 1px solid #00c3f9;color:#00c3f9;" @click="inputConfirm" plain>confirm</Button>
                </div>
            </mt-popup>
        </div>
    </div>
</template>
<script>
    import {
        registerVerify,DebounceBy,getSmsV,
        getUser,
        getWNum,
        getBank,
        withdraw_fee,
        getUserInfo,
        user_withdraw,
        user_withdraw_new,
        getTodayUserWithdraw,
        withdraw_info, getWithdrawPasswordFlag, withdraw_type
    } from "../../../api/user";
    import {required} from "@utils/validate";
    import {validatorDefaultCatch} from "@utils/dialog";
    import {Button,Toast, Field,Popup} from 'mint-ui'
    import 'mint-ui/lib/style.css'
    import navTitle from "@components/navTitle";

    export default {
        name: "UserCash",
        components: {
            navTitle,
            Button,
            'mt-field': Field,
            'mt-popup': Popup
        },
        props: {},
        data: function () {
            return {
                icon_moeny: this.global.moeny,
                is_load:false,

                money_switch: [300000, 500000, 1000000, 2000000, 5000000, 10000000],
                switch_index: 999,
                navList: [
                    {name: "Withdraw to bank account", type: "bank", icon: "icon-yinhangqia"},
                    {name: "Withdraw to balance", type: "balance", icon: "icon-weixin2"}
                    // { name: "支付宝", type: "alipay", icon: "icon-icon34" }
                ],
                my_cash: [],
                userInfo: {
                    now_money: 0
                },
                realFree: "0",
                realPrice: "0",
                now_money: "0",
                cashId: "", //选择的运营商
                cashUserName: "", //选择的提现账户
                post: {
                    extract_type: "bank",
                    alipay_code: "",
                    money: ""
                },
                currentTab: 0,
                minPrice: 0,
                banks: [],
                commissionCount: 0,
                showTips: "0",
                bomb_submit: false,
                showError: false,
                showPopup: false,
                captcha: '',
                w_data: '',
                errorMsg: '',
                countdown: 0,
                today_total_withdraw_money: 0,
                withdraw_pwd:'',
                yz_pwd:false,
                is_set_pwd:false
            };
        },
        watch: {
            cashId(n) {
                let list = this.cashList;
                list.forEach(item => {
                    if (item.id == n) {
                        this.cashUserName = item.account;
                    }
                });
            }
        },
        mounted: function () {
            this.getBank();
            this.getTodayWithdraw();
            // this.getWithdrawPassword()
        },
        methods: {
            setStr(str, num) {
                return str.substring(0, num) + "****" + str.substr(str.length - num);
            },
            getTodayWithdraw() {
                let that = this
                getTodayUserWithdraw().then(res => {
                    that.today_total_withdraw_money = res.data.total_money
                }).catch(res => {
                    // console.log(res)
                })
            },
            switchItem(money, index) {
                this.$set(this.post, 'money', money)
                this.switch_index = index
                this.getwithdraw_fee()
            },
            getwithdraw_fee() {
                withdraw_fee({money: this.post.money}).then(res => {
                    // console.log('getwithdraw_fee',res)
                    this.realPrice = res.data.money;
                    this.realFree = res.data.fee;
                }).catch(res => {
                    this.showError = true
                    this.errorMsg = res.msg
                })
            },
            swichNav: function (index, item) {
                this.currentTab = index;
                this.post.extract_type = item.type;
            },
            upAll() {
                this.post.money = this.userInfo.now_money;
                withdraw_fee({money: this.post.money}).then(res => {
                    this.realPrice = res.data.money;
                    this.realFree = res.data.fee;
                });
            },
            getBank: function () {
                // console.log(111)
                let that = this;
                this.$dialog.loading.open("Loading...");
                getUserInfo().then(res => {
                    (this.userInfo = res.data), (this.now_money = res.data.now_money);
                });

                withdraw_info().then(res => {
                    // console.log('getList',res.data)
                    that.$dialog.loading.close();

                    that.my_cash = res.data.my_cash; //已绑定列表
                    if(that.my_cash!==null) {
                        that.my_cash.bank_card = that.setStr(res.data.my_cash.bank_card, 4)
                        that.my_cash.bank_holder = that.setStr(res.data.my_cash.bank_holder, 2)
                    }
                    if (res.data.my_cash) {
                        that.showTips = "false"
                    } else {
                        that.showTips = "true"
                    }
                    that.is_load=true
                }).catch((err) => {
                        that.$dialog.loading.close();
                    })
            },
            async submitted() {
                let money = this.post.money,
                    that = this;

                if (!money) {
                    return that.$dialog.message("Please select withdraw amount");
                }
                if (
                    parseFloat(money) > parseFloat(that.userInfo.now_money) ||
                    parseFloat(that.userInfo.now_money) == 0
                )
                    return that.$dialog.message("Insufficient balance");
                if (parseFloat(money) < parseFloat(that.minPrice))
                    return that.$dialog.message("Minimum " + that.minPrice + "to withdraw");

                // 判断是否添加提现密码
                // console.log(that.is_set_pwd)
                /*if(!that.is_set_pwd){
                    this.$dialog.confirm({
                        mes: "Tetapkan sandi penarikan untuk memastikan dana akun lebih aman",
                        title: "Pengaturan sandi tarik",
                        opts: [
                            {
                                txt: "Confirm",
                                color: "#00C3F9",
                                callback: () => {
                                    that.$router.replace({
                                        path: "/user/myPay"
                                    })
                                }
                            },
                            {
                                txt: "Cancel",
                                color: false,
                                callback: () => {
                                    return that.$dialog.toast({ mes: "Cancelled" });
                                }
                            }
                        ]
                    })
                } else {
                    that.yz_pwd = true
                    // console.log(save)
                    // 输入提现密码
                    //发起提现
                    // that.save(save);
                }*/
                let save = {
                    money: this.post.money,
                    // withdraw_pwd:this.withdraw_pwd
                }

                that.smsTip(save);
            },

            smsTip:function (save) {
                // 判断是否是第一次提现
                let that = this
                getWNum().then(res1 => {
                    if(res1.data.level===0){
                        return Toast("Anda harus menjadi VIP untuk menarik uang");
                    }
                    if(res1.data.num===0){
                        getUser().then(res => {
                            that.phone = res.data.phone
                            that.w_data = save
                            that.showPopup = true
                            // console.log(that.showPopup)
                        })
                    } else {
                        that.save(save)
                    }
                })
                /*this.w_data = save
                let that = this
                getUser().then(res => {
                    that.phone = res.data.phone
                    that.showPopup = true
                })*/
            },
            inputCancel() {
                this.showPopup = false;
                // 处理取消逻辑
            },
            inputConfirm() {
                if(this.captcha==='')
                    return Toast("silakan masukkan kode verifikasi");
                let that = this;
                // that.save(this.w_data)
                getSmsV({ phone:that.phone,code: that.captcha}).then(res => {
                    that.showPopup = false
                    that.save(that.w_data)
                }).catch(res => {
                    Toast(res.msg);
                    // that.$dialog.error(res.msg);
                })
            },
            code: DebounceBy(function () {
                let that = this;
                if(!this.phone){
                    // return that.$dialog.error('Please enter your phone number');
                    return Toast('Masukkan nomor telepon anda');
                }
                registerVerify({ phone:that.phone })
                    .then(res => {
                        that.startCountdown()
                        Toast(res.msg);
                        // that.$dialog.success(res.msg);
                    }).catch(res => {
                    Toast(res.msg);
                    // that.$dialog.error(res.msg);
                })
            }),
            startCountdown() {
                // 设置初始倒计时时间（秒）
                const initialCountdown = 120

                // 开始倒计时
                this.countdown = initialCountdown

                // 设置定时器，每秒减少一秒
                const timer = setInterval(() => {
                    if (this.countdown > 0) {
                        this.countdown -= 1
                    } else {
                        // 倒计时结束，清除定时器
                        clearInterval(timer)
                    }
                }, 1000)
            },

            getWithdrawPassword() {
                let that = this
                getWithdrawPasswordFlag().then(res => {
                    that.is_set_pwd = res.data.flag
                    // that.is_set_pwd = true
                }).catch(res => {
                    this.$dialog.error('Silakan segar halaman');
                })
            },
            inputPassword(){
                if(this.withdraw_pwd===''){
                    return this.$dialog.error('Silakan masukkan sandi penarikan')
                }
                let param = {
                    money: this.post.money,
                    withdraw_pwd:this.withdraw_pwd
                }
                // console.log(param)
                this.save(param)
            },
            bgClose() {
                this.withdraw_pwd = ''
                this.yz_pwd = false
            },
            forgetPassword(){
                this.$router.push({path: "/user/myPay"});
            },
            save: function (info) {
                if (this.bomb_submit) {
                    return
                }

                this.bomb_submit = true
                this.$dialog.loading.open("Loading...");

                user_withdraw_new(info).then(
                    res => {
                        this.bgClose()
                        this.$dialog.loading.close();
                        this.bomb_submit = false
                        this.$dialog.message(res.msg);
                        this.$router.push({path: "/user/audit"});
                    },
                    error => {
                        this.$dialog.loading.close();
                        this.bomb_submit = false

                        this.$dialog.message(error.msg);
                    }
                );
            },
            test(){
                withdraw_type({id:1}).then(res=>{
                    console.log(res)
                })
            }
        }
    };
</script>
<style scoped>
    .cash-withdrawal {
        padding: 0.3rem 0.3rem 1rem 0.3rem;
        box-sizing: border-box;
        /*background: #FAFAFA;*/
    }

    .row-T1 {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        padding-left: 0.27rem;
        box-sizing: border-box;
    }

    .row-info {
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        padding-left: 0.27rem;
        box-sizing: border-box;
        color: #999;
        margin-top: -10px;
    }

    .row-error {
        width: 100%;
        box-sizing: border-box;
        color: #ff3c2b;
        margin-top: -10px;

    }

    .value-item {
        width: 100%;
        /*height: 5rem;*/
        background: #fff;
        padding: 0.27rem 0.27rem 0 0.27rem;
        box-sizing: border-box;
        margin-top: 0.3rem;
        margin-bottom: 0.3rem;
    }

    .value-item .flex {
        display: flex;
        width: 100%;
        height: 1.2rem;
        border-bottom: 1px solid #eee;
    }

    .value-item .T1 {
        width: 100%;
        height: 0.6rem;
        line-height: 0.6rem;
    }

    .value-item .flex .I1 {
        width: 0.4rem;
        font-size: 0.85rem;
        line-height: 1.2rem;
        height: 1.2rem;
    }

    .value-item .flex input {
        width: 6rem;
        border: none;
        line-height: 1.2rem;
        height: 1.2rem;
        font-size: 0.65rem;
        padding-left: 0.25rem;
        box-sizing: border-box;
    }

    .value-item .max {
        width: 100%;
        line-height: 1rem;
        height: 1rem;
    }

    .value-item .min {
        width: 100%;
        line-height: 0.5rem;
        height: 0.5rem;
    }

    .href {
        color: #0c7cd8;
    }

    .row-wrap {
        /*margin-bottom: 0.3rem;*/
    }

    .row {
        width: 100%;
        padding: 0 0.27rem;
        box-sizing: border-box;
        background: #fff;
        height: 0.75rem;
        line-height: 0.75rem;
        display: flex;
        position: relative;
    }

    .row::after {
        content: "";
        position: absolute;
        width: calc(100% - 0.27rem - 0.27rem);
        bottom: 0px;
        left: 0;
        right: 0;
        margin: 0 auto;
        height: 1px;
        background: #eee;
    }

    .row .row-name {
        width: 2.5rem;
    }

    .row .input {
        flex: 1;
        display: block;
        height: 0.75rem;
        line-height: 0.75rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .row .select {
        flex: 1;
        display: block;
        height: 0.75rem;
        line-height: 0.75rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .submit {
        width: 100%;
        height: 0.92rem;
        background: rgba(0, 195, 249, 1);
        border-radius: 7px;
        color: #fff;
        line-height: 0.92rem;
        text-align: center;
        font-size: 0.35rem;
        margin-top: 1rem;
    }


    .money-switch {
        width: 100%;
        display: flex;
        flex-wrap: wrap;


        box-sizing: border-box;
        background: #fff;
        border-radius: 3px;
        flex-direction: row;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
    }

    .money-switch .switch-item {
        width: 48%;
        border: 1px solid #ccc;
        border-radius: 3px;
        margin-bottom: 10px;
        line-height: 50px;
        height: 50px;
        /* margin-right: 10px; */
        color: #333;
        font-size: 0.36rem;
        text-align: center;

    }

    .money-switch .switch-item:nth-child(3n) {
        margin-right: 0px;
    }

    .switch-click {
        border: 1px solid #00c3f9 !important;
        color: #00c3f9 !important;

    }

    .switch-info {
        margin-bottom: 10px;
        color: #666;
        /*text-align: center;*/
    }

    #forPop {
        z-index: 999;
        width: 100%;
        height: 1000px;
        top: 0px;
        left: 0px;
        position: absolute;
        /*因为IE不支持opacity 所以用filter 为了兼容两个都写*/
        filter: Alpha(opacity=60);
        opacity: 0.6;
        background: #000000;
    }

    .set-pwd {
        z-index: 1000;
        background-color: #fff;
        width: 350px;
        height: auto;
        border-radius: 5px;
        /*border: #888888 2px solid;*/
        position: fixed;
        left: 50%;
        top: 50%;
        margin-top: -210px;
        margin-left: -175px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .set-tx-pwd-btn {
        display: block;
        width: 2.5rem;
        height: 0.86rem;
        margin: 0.2rem;
        float: left;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }
    .bg-qx {
        background-color: #f0f1f3;
    }
    .tx-pwd-title {
        font-weight: bold;
        text-align: center;
    }
    .forget-password{
        color: #ddd;
        text-align: right;
        padding-right: 0.2rem;
    }
</style>